import { useState, useEffect, useCallback } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'
import { deleteSalesTeamPosition } from '@user/store/salesTeam/api'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { SalesTeamPositionDeleteModel } from '../typings'

export const useDeleteSalesTeamPosition = () => {
  const dispatch = useAppDispatch()

  const [deleteModel, setDeleteModel] = useState<SalesTeamPositionDeleteModel>()
  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  const executeDelete = useCallback(
    (deleteModel: SalesTeamPositionDeleteModel) => {
      if (status != 'pending') setDeleteModel(deleteModel)
    },
    [status],
  )

  useEffect(() => {
    let mounted = true

    if (deleteModel) {
      const execute = async () => {
        try {
          const result = await dispatch(deleteSalesTeamPosition(deleteModel))

          if (mounted) {
            unwrapResult(result)
            setStatus('success')
          }
        } catch (error) {
          if (mounted) {
            setStatus('fail')
          }
        } finally {
          setDeleteModel(undefined)
        }
      }
      execute()
    }

    return () => {
      mounted = false
    }
  }, [deleteModel, dispatch])

  return executeDelete
}
